"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Traverses a path to collect links and nodes into an expression.
 */

var PathExpressionHandler =
/*#__PURE__*/
function () {
  function PathExpressionHandler() {
    _classCallCheck(this, PathExpressionHandler);
  }

  _createClass(PathExpressionHandler, [{
    key: "handle",
    value: function () {
      var _handle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pathData) {
        var segments, current, predicate, subject;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                segments = [];
                current = pathData; // Add all predicates to the path

              case 2:
                if (!current.parent) {
                  _context.next = 11;
                  break;
                }

                if (!current.predicate) {
                  _context.next = 8;
                  break;
                }

                _context.next = 6;
                return current.predicate;

              case 6:
                predicate = _context.sent;
                segments.unshift({
                  predicate: predicate
                });

              case 8:
                // Move to parent link
                current = current.parent;
                _context.next = 2;
                break;

              case 11:
                if (current.subject) {
                  _context.next = 13;
                  break;
                }

                throw new Error("Expected root subject in ".concat(current));

              case 13:
                _context.next = 15;
                return current.subject;

              case 15:
                subject = _context.sent;
                segments.unshift({
                  subject: subject
                });
                return _context.abrupt("return", segments);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function handle(_x) {
        return _handle.apply(this, arguments);
      }

      return handle;
    }()
  }]);

  return PathExpressionHandler;
}();

exports.default = PathExpressionHandler;